export default "__VITE_PUBLIC_ASSET__e83fd192__"